module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-3.00ed8156.webp";